module.exports = __webpack_public_path__ + "static/media/PokeBaller.aa52dabc.gif";